import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  IoSettingsOutline,
  IoBarChartOutline,
  IoVolumeHighSharp,
} from "react-icons/io5";
import Matter, {
  Engine,
  Render,
  Bodies,
  Composite,
  Events,
  Mouse,
  MouseConstraint,
} from "matter-js";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Ball from "../../assets/images/ball.png";
import PlinkoLogo from "../../assets/images/plinko-logo-2.png";
import UserIcon from "../../assets/images/user.png";
import CoinImage from "../../assets/images/coin.png";
import {
  InputComponent,
  SelectComponent,
  ButtonComponent,
  AudioModal,
} from "../common-components";
import { socketConn, access_token, adminId } from "../../helper/socket-io";
import { BetHistory } from "./bet-history";
import { InfoModel } from "./info-modal";
import { LiveStatsModal } from "./live-stats-modal";
import { initialData, list, riskOptionList } from "../../helper/utils";
import SoundFile from "../../assets/Walen - Nostalgia Gaming (freetouse.com).mp3";
import BallBounce from "../../assets/Switch Click V2.wav";

import PlinkoEngineNew from "./plinko-riya";
import {
  row8,
  row9,
  row10,
  row11,
  row12,
  row13,
  row14,
  row15,
  row16,
} from "../../helper/dataset";

export const Plinko = () => {
  const [isHovered, setIsHovered] = useState(true);
  const [openBetHistory, setOpenBetHistory] = useState(false);
  const [openLiveStatModal, setOpenLiveStatModal] = useState(false);
  const [socket, setSocket] = useState(null);
  const [activeTab, setActiveTab] = useState("tab1");
  const [gameConfig, setGameConfig] = useState([]);
  const [autoBetProcessDone, setAutoBetProcessDone] = useState(true);
  const [refreshGraph, setRefreshGraph] = useState(false);
  const [gridColor, setGridColor] = useState(null);
  const [resultDone, setResultDone] = useState(false);
  const [checkRisk, setCheckRisk] = useState(false);
  const [remain, setRemain] = useState(0);
  const [manualBetStarted, setManualBetStarted] = useState(false);
  const [autoBetStarted, setAutoBetStarted] = useState(false);
  const [dropPoint, setDropPoint] = useState(0);
 const [betNum, setBetNum] = useState(0)

  const [isConnected, setIsConnected] = useState(false);
  const [formData, setFormData] = useState({
    bet_amount: 0,
    risk: "low",
    rows: 8,
    num_of_bet: 0,
  });
  const [audioAllowModal, setAudioAllowModal] = useState({
    open: true,
    allow: false,
  });
  const [play, setPlay] = useState(false);
  const [place, setPlaced] = useState(false);
  const [betHistory, setBetHistory] = useState([]);
  const [betHistoryPayout, setBetHistoryPayouts] = useState([]);
  const [financeChart, setFinanceChart] = useState([]);
  const [riskOptions, setRiskOptions] = useState(riskOptionList);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [infoModalData, setInfoModalData] = useState({});
  const [openProfilePopover, setOpenProfielPopover] = useState(false);
  const [userDetails, setUserDetails] = useState(0);
  const [audioVolume, setAudioVolume] = useState(50);
  const containerRef = useRef(null);

  const [startResolve, setStartResolve] = useState({ bool: false, numOf: 0 });
  const [stopAuto, setStopAuto] = useState(false);

  const [worldWidth, setWorldWidth] = useState(650);
  const [worldHeight, setWorldHeight] = useState(660);
  const [margin, setMargin] = useState(30);
  const [payoutTable, setPayoutTable] = useState(initialData);
  const [pinSize, setPinSize] = useState(8);
  const [gridFontSize, setGridFontSize] = useState(15);
  const [adminId, setAdminId] = useState(null);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [resultantData, setResultantData] = useState(null);
  const [betResponse, setBetResponse] = useState(null);

  const maxReconnectAttempts = 5;
  let resposiveBallScale = 0.4;
  const [queryParams] = useSearchParams();
  const engine = Engine.create();
  const gridColors = {};
  const gridHeight = 50;
  const startPins = 3;
  const gridLines = [];
  let test = false;
  let responsiveWidth = window.innerWidth;

  const resizeHandler = () => {
    responsiveWidth = window.innerWidth;
    const box = document.getElementById("flipScreen");
    // console.log("responsiveWidth", responsiveWidth, formData.rows);
    if (responsiveWidth >= 1200) {
      // Desktop
      setWorldWidth(650);
      setWorldHeight(660);
      setMargin(30);
      setPinSize(6); // 6 8
      setGridFontSize(15);
      box.style.transform = "none";
    } else if (responsiveWidth <= 1199 && responsiveWidth > 992) {
      // Desktop
      setWorldWidth(650);
      setWorldHeight(660);
      setMargin(30);
      setPinSize(6); // 6 8
      setGridFontSize(15);
      box.style.transform = "none";
    } else if (responsiveWidth <= 991 && responsiveWidth > 768) {
      // Laptop

      let temp =
        formData.rows == 16
          ? 5
          : formData.rows == 15
          ? 5
          : formData.rows == 14
          ? 5
          : 8;
      setWorldWidth(650);
      setWorldHeight(660);
      setMargin(20);
      setPinSize(temp); // 5 temp
      setGridFontSize(15);
      box.style.transform = "none";
    } else if (responsiveWidth <= 768 && responsiveWidth > 576) {
      // Tablet
      setWorldWidth(350);
      setWorldHeight(400);
      setMargin(10);
      setPinSize(4);
      setGridFontSize(12);
    } else if (responsiveWidth <= 576) {
      // Mobile
      setWorldWidth(370);
      setWorldHeight(450);
      setMargin(10);
      setPinSize(4);
      setGridFontSize(10);
    }
  };

  useEffect(() => {
    resizeHandler();
    window.addEventListener("resize", resizeHandler);
    return () =>
      window.removeEventListener("resize", () => {
        resizeHandler();
      });
  }, []);

  useEffect(() => {
    if (activeTab == "tab2") {
      setRemain(formData.num_of_bet);
    }
  }, [formData.num_of_bet]);

  let render;

  useEffect(() => {
    // const container = containerRef.current;
    // container.style.display = "flex";
    // container.style.margin = "auto";
    // container.style.justifyContent = "center";
    // container.style.alignItems = "center";
    // if (gameConfig) {
    //   render = Render.create({
    //     element: container,
    //     engine: engine,
    //     options: {
    //       width: worldWidth,
    //       height: worldHeight + 50,
    //       wireframes: false,
    //       background: "#181D29",
    //     },
    //   });
    //   const pinGap = worldWidth / (Number(formData?.rows) + 2);
    //   const pins = [];
    //   let responsiveWidth = window.innerWidth;
    //   for (let l = 0; l < Number(formData?.rows); l++) {
    //     const linePins = startPins + l;
    //     const lineWidth = linePins * pinGap;
    //     for (let i = 0; i < linePins; i++) {
    //       const x = (worldWidth - (linePins - 1) * pinGap) / 2 + i * pinGap;
    //       let temp;
    //       let ballSize;
    //       if (responsiveWidth <= 576) {
    //         // mobile
    //         temp =
    //           formData?.rows == 8
    //             ? 43
    //             : formData?.rows == 9
    //             ? 35
    //             : formData?.rows == 10
    //             ? 27
    //             : formData?.rows == 11
    //             ? 22
    //             : formData?.rows == 12
    //             ? 15
    //             : formData?.rows == 13
    //             ? 10
    //             : formData?.rows == 14
    //             ? 5
    //             : formData?.rows == 15
    //             ? 5
    //             : formData?.rows == 16
    //             ? 0
    //             : 5;
    //         ballSize =
    //           formData?.rows == 8
    //             ? 0.3
    //             : formData?.rows == 9
    //             ? 0.3
    //             : formData?.rows == 10
    //             ? 0.3
    //             : formData?.rows == 11
    //             ? 0.3
    //             : formData?.rows == 12
    //             ? 0.3
    //             : formData?.rows == 13
    //             ? 0.2
    //             : formData?.rows == 14
    //             ? 0.2
    //             : formData?.rows == 15
    //             ? 0.2
    //             : formData?.rows == 16
    //             ? 0.2
    //             : 0.2;
    //         resposiveBallScale = ballSize;
    //       } else if (responsiveWidth <= 768 && responsiveWidth > 576) {
    //         ballSize =
    //           formData?.rows == 10
    //             ? 0.3
    //             : formData?.rows == 11
    //             ? 0.3
    //             : formData?.rows == 12
    //             ? 0.3
    //             : formData?.rows == 13
    //             ? 0.3
    //             : formData?.rows == 14
    //             ? 0.2
    //             : formData?.rows == 15
    //             ? 0.2
    //             : formData?.rows == 16
    //             ? 0.2
    //             : 0.5;
    //         resposiveBallScale = ballSize;
    //         temp =
    //           formData?.rows == 8
    //             ? 10
    //             : formData?.rows == 9
    //             ? 5
    //             : formData?.rows == 10
    //             ? -6
    //             : formData?.rows == 11
    //             ? -10
    //             : formData?.rows == 12
    //             ? -18
    //             : formData?.rows == 13
    //             ? -20
    //             : formData?.rows == 14
    //             ? -23
    //             : formData?.rows == 15
    //             ? -28
    //             : formData?.rows == 16
    //             ? -28
    //             : 5;
    //       } else {
    //         ballSize =
    //           formData?.rows == 14
    //             ? 0.4
    //             : formData?.rows == 15
    //             ? 0.4
    //             : formData?.rows == 16
    //             ? 0.4
    //             : 0.5;
    //         resposiveBallScale = ballSize;
    //         //
    //         temp =
    //           formData?.rows == 8
    //             ? 50
    //             : formData?.rows == 9
    //             ? 30
    //             : formData?.rows == 10
    //             ? 20
    //             : formData?.rows == 11
    //             ? 15
    //             : formData?.rows == 12
    //             ? 5
    //             : formData?.rows == 13
    //             ? -5
    //             : formData?.rows == 14
    //             ? -12
    //             : formData?.rows == 15
    //             ? -18
    //             : formData?.rows == 16
    //             ? -23
    //             : 5;
    //       }
    //       const y = 100 + l * pinGap + temp;
    //       const pin = Bodies.circle(x, y, pinSize, {
    //         label: "Pin",
    //         isStatic: true,
    //         // restitution: 0.005,
    //         // friction: 0.03,
    //         // frictionAir: 0.02,
    //         restitution: 0.9,
    //         friction: 0.02, // Surface friction
    //         frictionAir: 0.02, // Increase to slow down falling speed
    //         density: 0.001,
    //         render: {
    //           fillStyle: "#E8ECEF",
    //           strokeStyle: "#E8ECEF",
    //           shadowColor: "#E8ECEF",
    //           lineWidth: 2,
    //           shadowBlur: 20,
    //           shadowOffsetX: 3,
    //           shadowOffsetY: 3,
    //           customShader: function (ctx, body) {
    //             const gradient = ctx.createRadialGradient(
    //               body.position.x,
    //               body.position.y,
    //               pinSize * 0.2,
    //               body.position.x,
    //               body.position.y,
    //               pinSize * 2.5
    //             );
    //             ctx.fillStyle = gradient;
    //             ctx.fill();
    //             // Outer glow effect
    //             ctx.shadowBlur = 30;
    //             ctx.shadowColor = "rgba(255, 20, 147, 0.5)"; // Soft pink glow
    //           },
    //         },
    //       });
    //       pins.push(pin);
    //     }
    //   }
    //   Composite.add(engine.world, pins);
    //   const gridWidth = worldWidth / (Number(formData?.rows) + 1); // Grid should divide into 17 parts
    //   const basePadding = 5; // Default padding value
    //   const rowCount = Number(formData?.rows) || 1; // Ensure it's a valid number
    //   const padding = Math.max(5, basePadding - rowCount);
    //   // Decrease the height of the grid
    //   const newGridHeight = gridHeight * 0.7; // Reduce height to 70% (Adjust this value as needed)
    //   // Create 17 grid sections instead of 16
    //   for (let i = 0; i <= rowCount; i++) {
    //     const x = i * gridWidth + gridWidth / 2;
    //     const y = worldHeight - newGridHeight / 2 + 15; // Adjust Y position
    //     const grid = Bodies.rectangle(
    //       x,
    //       y,
    //       gridWidth - padding,
    //       newGridHeight - padding, // Apply reduced height
    //       {
    //         isStatic: true,
    //         render: {
    //           fillStyle: "transparent",
    //           lineWidth: 0,
    //           strokeStyle: "transparent",
    //         },
    //       }
    //     );
    //     gridLines.push(grid);
    //   }
    //   Composite.add(engine.world, gridLines);
    //   // Function to draw numbers under the grid sections
    //   const drawGridNumbers = () => {
    //     const ctx = render.context;
    //     const margin = 5; // Margin around each number box
    //     // **Reduce row height for smaller gradient rows**
    //     const rowHeight = gridHeight * 0.7 + margin * 2; // Adjust height considering margin
    //     // Group gridLines by rows (assuming they are in order)
    //     const rows = {};
    //     gridLines.forEach((grid) => {
    //       const rowIndex = Math.floor(grid.position.y / rowHeight);
    //       if (!rows[rowIndex]) rows[rowIndex] = [];
    //       rows[rowIndex].push(grid);
    //     });
    //     // Iterate through rows and apply gradient row-wise
    //     Object.values(rows).forEach((row) => {
    //       if (row.length === 0) return;
    //       // Get the first and last grid in the row to define the gradient
    //       const firstGrid = row[0];
    //       const lastGrid = row[row.length - 1];
    //       const gradient = ctx.createLinearGradient(
    //         firstGrid.position.x - gridWidth / 2,
    //         firstGrid.position.y - rowHeight / 2,
    //         lastGrid.position.x + gridWidth / 2,
    //         firstGrid.position.y + rowHeight / 2
    //       );
    //       gradient.addColorStop(0, "red");
    //       gradient.addColorStop(0.35, "orange");
    //       gradient.addColorStop(0.45, "yellow");
    //       gradient.addColorStop(0.45, "yellow");
    //       gradient.addColorStop(0.65, "orange");
    //       gradient.addColorStop(1, "red");
    //       // Apply the same gradient to all grids in this row
    //       row.forEach((grid, index) => {
    //         const textX = grid.position.x;
    //         const textY = grid.position.y - gridHeight * 0.25; // Adjust text Y position
    //         ctx.fillStyle = gradient;
    //         const marginX = 2; // Horizontal margin
    //         // ctx.fillRect(
    //         //   textX - gridWidth / 2 - 1 + marginX,
    //         //   textY - gridHeight * 0.3 + 15, // Decrease background height
    //         //   gridWidth - 2 * marginX,
    //         //   gridHeight * 0.6 // **Reduce height of gradient fill**
    //         // );
    //         const rectX = textX - gridWidth / 2 + margin / 2; // Add margin
    //         const rectY = textY - gridHeight * 0.3 + 15 + margin / 2; // Add margin
    //         const rectWidth = gridWidth - margin; // Reduce width for spacing
    //         const rectHeight = gridHeight * 0.8 - margin; // Reduce height for spacing
    //         const borderRadius = 5;
    //         ctx.beginPath();
    //         ctx.moveTo(rectX + borderRadius, rectY);
    //         ctx.lineTo(rectX + rectWidth - borderRadius, rectY);
    //         ctx.quadraticCurveTo(
    //           rectX + rectWidth,
    //           rectY,
    //           rectX + rectWidth,
    //           rectY + borderRadius
    //         );
    //         ctx.lineTo(rectX + rectWidth, rectY + rectHeight - borderRadius);
    //         ctx.quadraticCurveTo(
    //           rectX + rectWidth,
    //           rectY + rectHeight,
    //           rectX + rectWidth - borderRadius,
    //           rectY + rectHeight
    //         );
    //         ctx.lineTo(rectX + borderRadius, rectY + rectHeight);
    //         ctx.quadraticCurveTo(
    //           rectX,
    //           rectY + rectHeight,
    //           rectX,
    //           rectY + rectHeight - borderRadius
    //         );
    //         ctx.lineTo(rectX, rectY + borderRadius);
    //         ctx.quadraticCurveTo(rectX, rectY, rectX + borderRadius, rectY);
    //         ctx.closePath();
    //         ctx.fill(); // Fill the rounded rectangle
    //         if (!gridColors[index]) {
    //           // Store only if not already stored
    //           const pixelData = ctx.getImageData(textX, textY, 1, 1).data;
    //           const color = `rgba(${pixelData[0]}, ${pixelData[1]}, ${
    //             pixelData[2]
    //           }, ${pixelData[3] / 255})`;
    //           gridColors[index] = color; // Store color for this grid index
    //         }
    //         // Draw number text
    //         ctx.font = `bold ${gridFontSize}px 'Outfit', sans-serif`;
    //         ctx.fillStyle = "white";
    //         ctx.textAlign = "center";
    //         ctx.textBaseline = "middle";
    //         ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
    //         ctx.shadowBlur = 4;
    //         ctx.shadowOffsetX = 2;
    //         ctx.shadowOffsetY = 2;
    //         // if (payoutTable[Number(formData?.rows)]) {
    //           ctx.fillText(
    //             `${payoutTable[Number(formData?.rows)]?.[index] ?? 0}x`,
    //             textX,
    //             textY + 20 // Adjust text alignment to center
    //           );
    //         // }
    //       });
    //     });
    //   };
    //   const mouse = Mouse.create(render.canvas);
    //   const mouseConstraint = MouseConstraint.create(engine, {
    //     mouse: mouse,
    //     constraint: { stiffness: 0.2, render: { visible: false } },
    //   });
    //   Composite.add(engine.world, mouseConstraint);
    //   Matter.Events.on(mouseConstraint, "mousedown", (event) => {
    //     test = false;
    //     const mousePosition = event.mouse.position;
    //     // Find the clicked grid
    //     const clickedGridIndex = gridLines.findIndex((grid) => {
    //       return (
    //         mousePosition.x > grid.bounds.min.x &&
    //         mousePosition.x < grid.bounds.max.x &&
    //         mousePosition.y > grid.bounds.min.y &&
    //         mousePosition.y < grid.bounds.max.y
    //       );
    //     });
    //     if (clickedGridIndex !== -1) {
    //       const targetX = gridLines[clickedGridIndex].position.x;
    //       const options = [1.9, 2, 2.2];
    //       const randomValue =
    //         options[Math.floor(Math.random() * options.length)];
    //       const ballRadius = 5;
    //       const ballBody = Matter.Bodies.circle(
    //         worldWidth / randomValue,
    //         50,
    //         ballRadius,
    //         {
    //           label: "Ball",
    //           // restitution: 1,
    //           // friction: 0.03,
    //           // frictionAir: 0.5,
    //           restitution: 0.9,
    //           friction: 0.01, // Surface friction
    //           frictionAir: 0.1, // Increase to slow down falling speed
    //           density: 0.001,
    //           render: {
    //             sprite: {
    //               texture: Ball, // Replace with your image path
    //               xScale: resposiveBallScale, // 0.5, // Adjust scale if needed
    //               yScale: resposiveBallScale, // 0.5,
    //             },
    //           },
    //         }
    //       );
    //       engine.gravity.x = 0; // No horizontal gravity
    //       engine.gravity.y = -1; // Standard vertical gravity
    //       // Add the ball to the physics world
    //       Composite.add(engine.world, ballBody);
    //       // newly added
    //       const month = Array.from({ length: formData?.rows }, (_, i) => i);
    //       const yIndex = Math.floor(
    //         Math.random() * (formData?.rows - 5 - (formData?.rows - 5 - 3)) +
    //           (formData?.rows - 5 - 3)
    //       );
    //       let months = month.slice(2, 2 + 4);
    //       if (yIndex <= 4) {
    //         months = month.slice(2, 2 + 4);
    //       } else {
    //         months = month.slice(yIndex - 2, yIndex + 2);
    //       }
    //       const random = Math.floor(Math.random() * months.length);
    //       console.log(609, ">><<", random, months[random]);
    //       // newly added
    //       const ballDropSound = new Audio(SoundFile);
    //       Matter.Events.on(engine, "afterUpdate", () => {
    //         // let direction = targetX - ballBody.position.x;
    //         let direction = Math.floor(Math.random() * 3); //targetX - ballBody.position.x;
    //         if (test) {
    //           direction = targetX - ballBody.position.x;
    //         }
    //         const ballY = ballBody.position.y;
    //         if (Math.round(ballY / pinGap) == months[random]) {
    //           test = true;
    //         }
    //         Matter.Body.applyForce(ballBody, ballBody.position, {
    //           x: direction * 0.00001,
    //           y: 0,
    //         });
    //         const forceMagnitude = Math.random() * (6 - 5) + 5;
    //         // tweak this value for effect
    //         // console.log( forceMagnitude, direction * 0.00001);
    //         Matter.Body.setVelocity(ballBody, { x: 0, y: forceMagnitude }); // 5 8
    //         // Matter.Body.setVelocity(ballBody, { x: 0, y: 5 });
    //         Events.on(engine, "collisionStart", function (event) {
    //           const pairs = event.pairs;
    //           for (let i = 0; i < pairs.length; i++) {
    //             const pair = pairs[i];
    //             const { bodyA, bodyB } = pair;
    //             const ball = [bodyA, bodyB].find(
    //               (body) => body.label === "Ball"
    //             );
    //             const grid = [bodyA, bodyB].find(
    //               (body) => body.label === "Rectangle Body"
    //             );
    //             if(ball) {
    //               playSound(gameConfig.balldrop_sound_url, false);
    //             }
    //           }
    //         });
    //       });
    //     }
    //   });
    //   // Shiny shadow effect around each pin
    //   // Matter.Events.on(render, "afterRender", () => {
    //   //   const ctx = render.context;
    //   //   pins.forEach((pin) => {
    //   //     const { position } = pin;
    //   //     // Create a radial gradient for the glow effect
    //   //     const shadowGradient = ctx.createRadialGradient(
    //   //       position.x,
    //   //       position.y,
    //   //       pinSize * 0.2, // Inner glow
    //   //       position.x,
    //   //       position.y,
    //   //       pinSize * 2 // Outer glow
    //   //     );
    //   //     // shadowGradient.addColorStop(0, "rgb(244, 244, 244)"); // Light Blue Center
    //   //     // shadowGradient.addColorStop(0.4, "rgba(135, 206, 250, 0.5)"); // Sky Blue Mid
    //   //     // shadowGradient.addColorStop(1, "rgba(70, 130, 180, 0)"); // Steel Blue Fade Out
    //   //     // Draw the shadow
    //   //     ctx.beginPath();
    //   //     ctx.arc(position.x, position.y, pinSize * 2, 0, Math.PI * 2);
    //   //     ctx.fillStyle = shadowGradient;
    //   //     ctx.fill();
    //   //   });
    //   // });
    //   Render.run(render);
    //   const runner = Engine.run(engine);
    //   (function renderLoop() {
    //     requestAnimationFrame(renderLoop);
    //     Engine.update(engine, 1000 / 60);
    //     drawGridNumbers();
    //   })();
    //   // engine.gravity.x = 0; // No horizontal gravity
    //   // engine.gravity.y = 1; // Standard vertical gravity
    //   let lastPinHitTime = 0;
    //   const playBallDropSound = () => {
    //     const now = Date.now();
    //     // Ensure sound plays at least 100ms apart
    //     if (now - lastPinHitTime > 10) {
    //       const ballDropSound = new Audio(SoundFile); // Create a new sound instance
    //       ballDropSound.volume = audioVolume;
    //       ballDropSound.play();
    //       lastPinHitTime = now; // Update the last play time
    //     }
    //   };
    //   Events.on(engine, "collisionStart", (event) => {
    //     event.pairs.forEach((pair) => {
    //       if (gridLines.includes(pair.bodyB)) {
    //       }
    //       const { bodyA, bodyB } = pair;
    //       // Check if either body is a ball and the other is a grid
    //       const ball = [bodyA, bodyB].find((body) => body.label === "Ball");
    //       const grid = [bodyA, bodyB].find((body) =>
    //         body.label?.startsWith("Rectangle Body")
    //       );
    //       const pin = [bodyA, bodyB].find((body) => body.label === "Pin");
    //       // if (ball) {
    //       //   ballDropSound.volume = audioVolume;
    //       //   ballDropSound.currentTime = 0;
    //       //   ballDropSound.play();
    //       // }
    //       if (ball && grid) {
    //         // Move the grid body slightly downward with a smaller shift
    //         Matter.Body.translate(grid, { x: 0, y: 10 }); // Moves down by 3px instead of 10px
    //         // Reduce ball opacity and remove it
    //         ball.render.opacity = 0.5;
    //         Matter.World.remove(engine.world, ball);
    //         // Reset grid position and color after a short delay
    //         setTimeout(() => {
    //           Matter.Body.translate(grid, { x: 0, y: -10 }); // Move it back up
    //           Matter.World.remove(engine.world, ball);
    //         }, 500);
    //         setTimeout(() => {
    //           if(ball) {
    //             playSound(gameConfig.balldrop_sound_url, false);
    //           }
    //           // ballDropSound.pause();
    //           // ballDropSound.currentTime = 0; // Reset sound
    //         }, 50);
    //       }
    //       if (ball && pin) {
    //         // console.log("ball & pin:--------------", pin);
    //         // playBallDropSound();
    //         if (pin) {
    //           let scale = 1.5;
    //           let opacity = 0.7;
    //           const updateGlow = () => {
    //             pin.render.strokeStyle = `rgba(255, 20, 147, ${opacity})`; // Pink glow with fading effect
    //             pin.render.lineWidth = scale * 8; // Glow expands
    //             scale += 0.1; // Increase size for smooth effect
    //             opacity -= 0.08; // Fade out
    //             if (opacity > 0) {
    //               requestAnimationFrame(updateGlow);
    //             } else {
    //               pin.render.strokeStyle = "transparent"; // Remove glow
    //               pin.render.lineWidth = 0;
    //             }
    //           };
    //           updateGlow();
    //         }
    //       }
    //     });
    //   });
    //   return () => {
    //     Engine.clear(engine);
    //     Render.stop(render);
    //     render.canvas.remove();
    //   };
    // }
  }, [margin, gameConfig, formData?.rows, formData?.risk]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (/^\d*$/.test(value)) {
      if (name == "num_of_bet") {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value <= 100 ? value : 100,
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }

      if (socket) {
        // socket.emit(
        //   "config",
        //   {
        //     adminId: null,
        //   },
        //   (response) => {
        //     console.log("config call 731", response);
        //     if (response.status) {
        //       setGameConfig(response.data);
        //     } else {
        //       toast.warn(response.message);
        //     }
        //   }
        // );
      } else {
        setSocket(null);
      }
    }
  };

  const audioRef = useRef(null);

  // Play sound
  const playSound = (url, run) => {
    console.log("play", url, audioVolume, audioAllowModal.allow);
    if (audioAllowModal.allow && url) {
      if (!audioRef.current) {
        console.log("baja");
        audioRef.current = new Audio(url);
        audioRef.current.loop = true;
        audioRef.current.play().catch((e) => console.error(e));
      }
      if (!run) {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current = null;
        }
      }
      if (audioRef.current) {
        audioRef.current.volume = audioVolume / 100;
      }
      // Set initial volume
    }
  };
  // Update volume runtime
  const changeVolume = (newVolume) => {
    setAudioVolume(newVolume);
   console.log(newVolume)
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  // const playSound = (url, run) => {
  //   const audio = new Audio(url);
  //   audio.volume = audioVolume;
  //   audio.play();
  //   // Reset state when audio ends
  //   audio.onended = () => {};
  //   if (!run) {
  //     audio.pause();
  //   }
  // };

  useEffect(() => {
    if (formData.risk && gameConfig) {
      console.log("config 792", formData.risk, formData.rows, gameConfig);
      if (formData.risk == "low") {
        setPayoutTable(gameConfig.low_payout_table);
        setCheckRisk(true);
      } else if (formData.risk == "medium") {
        setPayoutTable(gameConfig.medium_payout_table);
        setCheckRisk(true);
      } else if (formData.risk == "high") {
        setPayoutTable(gameConfig.high_payout_table);
        setCheckRisk(true);
      }
      let count = formData.rows;
      setFormData((prev) => ({ ...prev, rows: 0 }));
      setTimeout(() => {
        if (formData.rows == 0) {
          setFormData((prev) => ({ ...prev, rows: 8 }));
        } else {
          setFormData((prev) => ({ ...prev, rows: count }));
        }
      }, 1000);
    }
  }, [formData.risk, gameConfig]);

  const handleChangeSelection = (event) => {
    const { value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      risk: value,
    }));
    // setPayoutTable(initialData);
    // socket.emit(
    //   "config",
    //   {
    //     adminId: null,
    //   },
    //   (response) => {
    //     if (response.status) {
    //       console.log("config call 800", response)
    //       let count = formData.rows;
    //       setFormData((prev) => ({ ...prev, rows: 0 }));

    //       setTimeout(() => {
    //         setFormData((prev) => ({ ...prev, rows: count }));
    //       }, 2000);

    //       const tempPayout =
    //         value == "low"
    //           ? response.data?.low_payout_table
    //           : value == "medium"
    //           ? response.data?.medium_payout_table
    //           : value == "high"
    //           ? response.data?.high_payout_table
    //           : response.data?.low_payout_table;

    //       console.log("set payoutTable", tempPayout);
    //       setPayoutTable(tempPayout);
    //       setCheckRisk(true)

    //       if (response?.data?.background_sound_url) {
    //         playSound(response?.data?.background_sound_url, true);
    //       } else {
    //         playSound(SoundFile, true);
    //       }

    //       setFormData((prevState) => ({
    //         ...prevState,
    //         risk: value,
    //       }));
    //     } else {
    //       toast.warn(response.message);
    //     }
    //   }
    // );
  };

  useEffect(() => {
    if (betResponse && gridColor && payoutTable && resultantData?.result) {
      // console.log(gridColor, gridColor[(resultantData.result.split('_')[1])])
      if (resultantData) {
        setTimeout(() => {
          storeResultEvent(
            payoutTable[Number(formData?.rows)][Number(betResponse?.dropPoint)] *
              Number(formData?.bet_amount),
            betResponse?._id,
            payoutTable[Number(formData?.rows)][Number(betResponse?.dropPoint)],
            gridColor[resultantData.result.split("_")[1]], // gridColors[response.data?.dropPoint],
            betResponse?.multiplier
          );
        }, 1000);
        

        setResultantData(null);
      }
    }
    if(!resultantData?.result) {
      setResultantData(null);
      setManualBetStarted(false);

        setAutoBetStarted(false);
    }
  }, [gridColor]);

  useEffect(() => {
   
    if (resultDone) {
      if (activeTab == "tab2" && !stopAuto) {
        if (
          startResolve.bool &&
          startResolve.numOf < Number(formData?.num_of_bet)
        ) {
          const u = startResolve.numOf
          console.log("903", startResolve, u, betNum)
          if(startResolve.numOf < u) {
            console.log("else")
          } else {
            console.log("place here", u, startResolve.numOf)
            placeBet(startResolve.numOf);
          }
         
        } else if (
          startResolve.bool &&
          startResolve.numOf == Number(formData?.num_of_bet)
        ) {
          setFormData((prev) => ({
            ...prev,
            bet_amount: 0,
            risk: "low",
            rows: formData.rows,
            num_of_bet: 0,
          }));
          setAutoBetProcessDone(true);
        }
      } else {
        
        if (startResolve.bool && activeTab == "tab2") {
          toast.warn("Auto Bet stopped");
          setFormData((prev) => ({
            ...prev,
            bet_amount: 0,
            risk: "low",
            rows: 8,
            num_of_bet: 0,
          }));
          setAutoBetProcessDone(true);
          setStartResolve({ bool: false, numOf: 0 });
        }
      }
    }
  }, [ stopAuto,resultDone ]); // ,

  const connectSocket = useCallback(() => {
    if (!socketConn.connected) {
      socketConn.connect();
    }

    // On successful connection
    socketConn.on("connect", () => {
      console.log("Connected to server");
      setSocket(socketConn);
      setIsConnected(true);
      toast.success("socket connected");
      setReconnectAttempts(0); // Reset reconnect attempts
    });

    // socketConn.on("refund", (response) => {
    //   console.log("refund", response);
    //   if (response.refund) {
    //     toast.warn(response.refund);
    //   }
    // });

    // On disconnection - Attempt to reconnect
    socketConn.on("disconnect", () => {
      console.warn("Disconnected from server");
      toast.error("socket disconnected");
      setSocket(null);
      setIsConnected(false);
      attemptReconnect();
    });

    // Handle connection errors
    socketConn.on("connect_error", (error) => {
      console.error("Connection error:", error);
      toast.error("Socket connection error");
      setIsConnected(false);
      attemptReconnect();
    });

    // Cleanup on unmount
    return () => {
      socketConn.off("connect");
      socketConn.off("disconnect");
      socketConn.off("connect_error");
      socketConn.disconnect();
    };
  }, []);

  const attemptReconnect = () => {
    // if (reconnectAttempts < maxReconnectAttempts) {
    //   const delay = Math.min(5000, 1000 * 2 ** reconnectAttempts); // Exponential backoff
    //   console.log(`Attempting to reconnect in ${delay / 1000} seconds...`);
    //   // setTimeout(() => {
    //     setReconnectAttempts((prev) => prev + 1);
    //     connectSocket();
    //   // }, delay);
    // } else {
    //   console.error("Max reconnection attempts reached");
    //   toast.error("Unable to reconnect to the server.");
    // }
  };

  useEffect(() => {
    const cleanup = connectSocket();
    return () => {
      cleanup();

      setSocket(null);
    };
  }, [connectSocket]);

  useEffect(() => {
    if (socket && isConnected) {
      socket.emit("config", { adminId: null }, (response) => {
        console.log(1010, response);
        if (response.status) {
          // setPayoutTable(initialData)
          setGameConfig(response.data);
          // setPinSize(Math.max(worldWidth / (Number(formData?.rows) * 8), 8));

          if (formData.risk == "low") {
            setPayoutTable(response.data?.low_payout_table);
            setCheckRisk(true);
          } else if (formData.risk == "medium") {
            setPayoutTable(response.data?.medium_payout_table);
            setCheckRisk(true);
          } else if (formData.risk == "high") {
            setPayoutTable(response.data?.high_payout_table);
            setCheckRisk(true);
          }

          // navigator.mediaDevices
          //   .getUserMedia({ audio: true })
          //   .then(() => {

          if (audioAllowModal.allow) {
            if (response?.data?.background_sound_url) {
              playSound(response?.data?.background_sound_url, true);
            } else {
              playSound(SoundFile, true);
            }
          }

          // })
          // .catch(() => {
          //   alert("Please enable audio permissions to play sounds.");
          // });
        } else {
          toast.warn(response.message);
        }
      });

      socket.emit("betHistory", {}, (response) => {
        if (response.status) {
          setBetHistory(response.data);
        } else {
          toast.warn(response.message);
        }
      });

      socket.emit("userDetails", {}, (response) => {
        if (response.status) {
          setUserDetails(response.data);
        } else {
          toast.warn(response.message);
        }
      });
    }
  }, [socket, queryParams, audioAllowModal, isConnected]);

  useEffect(() => {
    if (socket) {
      socket.emit("betHistory", {}, (response) => {
        if (response.status) {
          setBetHistory(response.data);
        } else {
          toast.warn(response.message);
        }
      });
      socket.emit("betHistoryPayouts", {}, (response) => {
        if (response.status) {
          setBetHistoryPayouts(response.data);
        } else {
          toast.warn(response.message);
        }
      });
    }
  }, [socket, socket?.connected]);

  const placeBet = (numOf) => {
    setDropPoint(0);

    setGridColor(null);
    if (formData.bet_amount < gameConfig.min_bet) {
      toast.warn(`Bet Amount should be more than ${gameConfig.min_bet}.`);
      return;
    }
    if (!formData?.bet_amount) {
      toast.warn(`Invalid bet amount`);
      return;
    }

    if (Number(formData?.bet_amount) > gameConfig.max_bet) {
      toast.warn(
        `You cannot enter bet amount more than max bet amount (${gameConfig.max_bet}).`
      );
      return;
    }
    if (!formData?.risk) {
      toast.warn("Please select Risk Level");
      return;
    }
    if (
      Number(formData?.bet_amount) < gameConfig.min_bet &&
      Number(formData?.bet_amount) > gameConfig.max_bet
    ) {
      toast.warn(
        `Bet amount should be more than (${gameConfig.min_bet}) and less than (${gameConfig.max_bet})`
      );
      return;
    }
    if (activeTab == "tab2" && formData.num_of_bet < 2) {
      toast.warn("Number of bet should be more than (1) in Auto bet.");
      return;
    }
    return new Promise((resolve, reject) => {
      if (!socket) {
        toast.warn("Socket disconnected");
        return reject(new Error("Socket disconnected"));
      }
      // setStartResolve({ bool: false, numOf: numOf });
      setPlaced(true);
      // console.log(1118, {
      //   betAmount: Number(formData?.bet_amount),
      //   rows: Number(formData?.rows),
      //   risk: formData?.risk,
      //   engine_id: gameConfig.engine_id,
      // })
      socket.emit(
        "placeBet",
        {
          betAmount: Number(formData?.bet_amount),
          rows: Number(formData?.rows),
          risk: formData?.risk,
          engine_id: gameConfig.engine_id,
        },
        (response) => {
          setResultDone(false)

          

          if (!response.status || !response.data) {
            toast.warn(response.message || "Bet failed");
            setAutoBetProcessDone(true);
            setStopAuto(true);
            setPlaced(false);
            setFormData((prev) => ({
              ...prev,
              bet_amount: 0,
              
              num_of_bet: 0,
            }));

            return;
          }
          if (activeTab == "tab1") {
            setManualBetStarted(true);
          }
          if (activeTab == "tab2") {
            setBetNum(betNum+1)
            setAutoBetStarted(true);
          }

          socket.emit("userDetails", {}, (response) => {
            if (response.status) {
              setUserDetails(response.data);
            } else {
              toast.warn(response.message);
            }
          });

          if (response.data) {
            // console.log(

            //   "dropPoint",
            //   response.data.dropPoint,
            //   "multiplier",
            //   response?.data?.multiplier
            // );
            setDropPoint(response?.data?.multiplier);

            if (formData.rows == 8) {
              const outout = row8.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              } else {
                setResultantData({rows: 8})
              }
            } else if (formData.rows == 9) {
              const outout = row9.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              } else {
                setResultantData({rows: 9})
              }
            } else if (formData.rows == 10) {
              const outout = row10.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              }
              else {
                setResultantData({rows: 10})
              }
            } else if (formData.rows == 11) {
              const outout = row11.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              } else {
                setResultantData({rows: 11})
              }
            } else if (formData.rows == 12) {
              const outout = row12.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              }else {
                setResultantData({rows: 12})
              }
            } else if (formData.rows == 13) {
              const outout = row13.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              } else {
                setResultantData({rows: 13})
              }
            } else if (formData.rows == 14) {
              const outout = row14.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              } else {
                setResultantData({rows: 14})
              }
            } else if (formData.rows == 15) {
              const outout = row15.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              } else {
                setResultantData({rows: 15})
              }
            } else if (formData.rows == 16) {
              
              const outout = row16.filter(
                (itm) => itm.result.split("_")[1] == response?.data?.dropPoint
              );
              console.log(1247, outout)

              if (outout.length > 0) {
                const randomValue = Math.floor(Math.random() * outout.length);
                setResultantData(outout[randomValue]);
              }
              else {
                setResultantData({rows: 16})
              }
            }
          }

          try {
            setBetResponse(response.data);
            //  console.log(1003, payoutTable)

            //   return resolve({
            //   success: true,
            // });
            // Toggle to refresh UI
            // if (response.status && response.data) {
            //   if (render == null) {
            //     // Render.stop(render);
            //     // render.canvas.remove();
            //     render = Render.create({
            //       element: container,
            //       engine: engine,
            //       options: {
            //         width: worldWidth,
            //         height: worldHeight + 100,
            //         wireframes: false,
            //         background: "#181D29",
            //       },
            //     });
            //     Render.run(render);
            //   }
            //   const container = containerRef.current;
            //   container.style.display = "flex";
            //   container.style.justifyContent = "center";
            //   container.style.alignItems = "center";
            //   const gridWidth = worldWidth / (Number(formData?.rows) + 1);
            //   const drawGridNumbers = () => {
            //     const ctx = render.context;
            //     const margin = 5; // Margin around each number box
            //     // **Reduce row height for smaller gradient rows**
            //     const rowHeight = gridHeight * 0.7 + margin * 2; // Decreased height
            //     // Group gridLines by rows (assuming they are in order)
            //     const rows = {};
            //     gridLines.forEach((grid) => {
            //       const rowIndex = Math.floor(grid.position.y / rowHeight);
            //       if (!rows[rowIndex]) rows[rowIndex] = [];
            //       rows[rowIndex].push(grid);
            //     });
            //     // Iterate through rows and apply gradient row-wise
            //     Object.values(rows).forEach((row) => {
            //       if (row.length === 0) return;
            //       // Get the first and last grid in the row to define the gradient
            //       const firstGrid = row[0];
            //       const lastGrid = row[row.length - 1];
            //       const gradient = ctx.createLinearGradient(
            //         firstGrid.position.x - gridWidth / 2,
            //         firstGrid.position.y - rowHeight / 2,
            //         lastGrid.position.x + gridWidth / 2,
            //         firstGrid.position.y + rowHeight / 2
            //       );
            //       gradient.addColorStop(0, "red");
            //       gradient.addColorStop(0.35, "orange");
            //       gradient.addColorStop(0.45, "yellow");
            //       gradient.addColorStop(0.45, "yellow");
            //       gradient.addColorStop(0.65, "orange");
            //       gradient.addColorStop(1, "red");
            //       // Apply the same gradient to all grids in this row
            //       row.forEach((grid, index) => {
            //         const textX = grid.position.x;
            //         const textY = grid.position.y - gridHeight * 0.25; // Adjust text Y position
            //         ctx.fillStyle = gradient;
            //         const marginX = 2; // Horizontal margin
            //         // ctx.fillRect(
            //         //   textX - gridWidth / 2 - 1 + marginX,
            //         //   textY - gridHeight * 0.3 + 15, // Decrease background height
            //         //   gridWidth - 2 * marginX,
            //         //   gridHeight * 0.6 // **Reduce height of gradient fill**
            //         // );
            //         const rectX = textX - gridWidth / 2 + margin / 2; // Add margin
            //         const rectY = textY - gridHeight * 0.3 + 15 + margin / 2; // Add margin
            //         const rectWidth = gridWidth - margin; // Reduce width for spacing
            //         const rectHeight = gridHeight * 0.8 - margin; // Reduce height for spacing
            //         const borderRadius = 5;
            //         ctx.beginPath();
            //         // Draw rounded rectangle with spacing
            //         ctx.moveTo(rectX + borderRadius, rectY);
            //         ctx.lineTo(rectX + rectWidth - borderRadius, rectY);
            //         ctx.quadraticCurveTo(
            //           rectX + rectWidth,
            //           rectY,
            //           rectX + rectWidth,
            //           rectY + borderRadius
            //         );
            //         ctx.lineTo(
            //           rectX + rectWidth,
            //           rectY + rectHeight - borderRadius
            //         );
            //         ctx.quadraticCurveTo(
            //           rectX + rectWidth,
            //           rectY + rectHeight,
            //           rectX + rectWidth - borderRadius,
            //           rectY + rectHeight
            //         );
            //         ctx.lineTo(rectX + borderRadius, rectY + rectHeight);
            //         ctx.quadraticCurveTo(
            //           rectX,
            //           rectY + rectHeight,
            //           rectX,
            //           rectY + rectHeight - borderRadius
            //         );
            //         ctx.lineTo(rectX, rectY + borderRadius);
            //         ctx.quadraticCurveTo(
            //           rectX,
            //           rectY,
            //           rectX + borderRadius,
            //           rectY
            //         );
            //         ctx.closePath();
            //         ctx.fill(); // Fill the rounded rectangle
            //         // if (!gridColors[index]) {
            //         //   // Store only if not already stored
            //         //   const pixelData = ctx.getImageData(
            //         //     textX,
            //         //     textY,
            //         //     1,
            //         //     1
            //         //   ).data;
            //         //   const color = `rgba(${pixelData[0]}, ${pixelData[1]}, ${
            //         //     pixelData[2]
            //         //   }, ${pixelData[3] / 255})`;
            //         //   gridColors[index] = color; // Store color for this grid index
            //         // }
            //         requestAnimationFrame(() => {
            //           const pixelData = ctx.getImageData(
            //             rectX + rectWidth / 2,
            //             rectY + rectHeight / 2,
            //             1,
            //             1
            //           ).data;
            //           const color = `rgba(${pixelData[0]}, ${pixelData[1]}, ${
            //             pixelData[2]
            //           }, ${pixelData[3] / 255})`;
            //           gridColors[index] = color; // Store the accurate color
            //         });
            //         // Draw number text
            //         ctx.font = `bold ${gridFontSize}px 'Outfit', sans-serif`;
            //         ctx.fillStyle = "white";
            //         ctx.textAlign = "center";
            //         ctx.textBaseline = "middle";
            //         ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
            //         ctx.shadowBlur = 4;
            //         ctx.shadowOffsetX = 2;
            //         ctx.shadowOffsetY = 2;
            //         if (payoutTable[Number(formData?.rows)]) {
            //           ctx.fillText(
            //             `${payoutTable[Number(formData?.rows)]?.[index] ?? 0}x`,
            //             textX,
            //             textY + 20 // Adjust text alignment to center
            //           );
            //         }
            //       });
            //     });
            //   };
            //   const targetX = gridLines[response.data?.dropPoint]?.position.x;
            //   const ballRadius = 5;
            //   const options = [1.9, 2, 2.2];
            //   const randomValue =
            //     options[Math.floor(Math.random() * options.length)];
            //   const ballBody = Matter.Bodies.circle(
            //     worldWidth / randomValue,
            //     50,
            //     ballRadius,
            //     {
            //       // label: "Ball",
            //       // restitution: 0.8,
            //       // friction: 0.03, // Surface friction
            //       // frictionAir: 0.3, // Increase to slow down falling speed
            //       // density: 0.001,
            //       // render: {
            //       //   sprite: {
            //       //     texture: Ball, // Replace with your image path
            //       //     xScale: 0.5, // Adjust scale if needed
            //       //     yScale: 0.5,
            //       //   },
            //       // },
            //       label: "Ball",
            //       restitution: 0.3, // Less bounciness (was 0.8)
            //       friction: 0.05, // Slight friction for smoother slides (was 0.03)
            //       frictionAir: 0.01, // Reduced air resistance for natural speed (was 0.3)
            //       density: 0.0005, // Lower density for lighter ball (was 0.001)
            //       render: {
            //         sprite: {
            //           texture: Ball, // Replace with your image path
            //           xScale: resposiveBallScale,
            //           yScale: resposiveBallScale,
            //         },
            //       },
            //     }
            //   );
            //   Composite.add(engine.world, ballBody);
            //   Render.run(render);
            //   const runner = Engine.run(engine);
            //   (function renderLoop() {
            //     requestAnimationFrame(renderLoop);
            //     Engine.update(engine, 1000 / 60);
            //     drawGridNumbers();
            //   })();
            //   // const ballDropSound = new Audio(SoundFile);
            //   // newly added
            //   const month = Array.from({ length: formData?.rows }, (_, i) => i);
            //   const yIndex = Math.floor(
            //     Math.random() *
            //       (formData?.rows - 5 - (formData?.rows - 5 - 3)) +
            //       (formData?.rows - 5 - 3)
            //   );
            //   let months = month.slice(2, 2 + 4);
            //   if (yIndex <= 4) {
            //     months = month.slice(2, 2 + 4);
            //   } else {
            //     months = month.slice(yIndex - 2, yIndex + 2);
            //   }
            //   const random = Math.floor(Math.random() * months.length);
            //   // console.log(609, ">><<", random, months[random]);
            //   // newly added
            //   const pinGap = worldWidth / (Number(formData?.rows) + 2);
            //   Matter.Events.on(engine, "afterUpdate", () => {
            //     // let direction = targetX - ballBody.position.x;
            //     let direction = Math.floor(Math.random() * 3); //targetX - ballBody.position.x;
            //     if (test) {
            //       direction = targetX - ballBody.position.x;
            //     }
            //     const ballY = ballBody.position.y;
            //     if (Math.round(ballY / pinGap) == months[random]) {
            //       // console.log(direction);
            //       test = true;
            //     }
            //     Matter.Body.applyForce(ballBody, ballBody.position, {
            //       x: direction * 0.00001,
            //       y: 0,
            //     });
            //     const forceMagnitude = Math.random() * (6 - 5) + 5;
            //     Matter.Body.setVelocity(ballBody, { x: 0, y: forceMagnitude });
            //   });
            //   // engine.gravity.x = 0; // No horizontal gravity
            //   // engine.gravity.y = 1; // Standard vertical gravity
            //   Events.on(engine, "collisionStart", async (event) => {
            //     const pairs = event.pairs;
            //     for (let i = 0; i < pairs.length; i++) {
            //       const pair = pairs[i];
            //       const { bodyA, bodyB } = pair;
            //       const ball = [bodyA, bodyB].find(
            //         (body) => body.label === "Ball"
            //       );
            //       const grid = [bodyA, bodyB].find((body) =>
            //         body.label?.startsWith("Rectangle Body")
            //       );
            //       const pin = [bodyA, bodyB].find(
            //         (body) => body.label !== "Ball"
            //       );
            //       if (ball) {
            //         // ballDropSound.volume = audioVolume;
            //         // ballDropSound.currentTime = 0;
            //         // ballDropSound.play();
            //       }
            //       if (ball && grid) {
            //         // Move the grid body slightly downward with a smaller shift
            //         // Reduce ball opacity and remove it
            //         ball.render.opacity = 0.5;
            //         Matter.World.remove(engine.world, ball);
            //         // Reset grid position and color after a short delay
            //         setTimeout(async () => {
            //           Matter.World.remove(engine.world, ball);
            //           if (payoutTable[Number(formData?.rows)]) {
            //             await storeResultEvent(
            //               payoutTable[Number(formData?.rows)][
            //                 Number(response.data?.dropPoint)
            //               ] * Number(formData?.bet_amount),
            //               response?.data?._id,
            //               payoutTable[Number(formData?.rows)][
            //                 Number(response.data?.dropPoint)
            //               ],
            //               gridColors[response.data?.dropPoint],
            //               response.data?.multiplier
            //             );
            //           }
            //         }, 500);
            //         setTimeout(() => {
            //           // ballDropSound.pause();
            //           // ballDropSound.currentTime = 0; // Reset sound
            //           return resolve({
            //             success: true,
            //           });
            //         }, 50);
            //       }
            //       if (ball && pin) {
            //         if (pin) {
            //           let scale = 1.5;
            //           let opacity = 0.7;
            //           const updateGlow = () => {
            //             pin.render.strokeStyle = `rgba(255, 20, 147, ${opacity})`; // Pink glow with fading effect
            //             pin.render.lineWidth = scale * 8; // Glow expands
            //             scale += 0.1; // Increase size for smooth effect
            //             opacity -= 0.08; // Fade out
            //             if (opacity > 0) {
            //               requestAnimationFrame(updateGlow);
            //             } else {
            //               pin.render.strokeStyle = "transparent"; // Remove glow
            //               pin.render.lineWidth = 0;
            //             }
            //           };
            //           updateGlow();
            //           const bounceForceX = (Math.random() - 0.5) * 0.02; // Randomized horizontal push (stronger bounce)
            //           const bounceForceY = -0.01; // Upward bounce (increase height)
            //           Matter.Body.applyForce(ball, ball.position, {
            //             x: bounceForceX,
            //             y: bounceForceY,
            //           });
            //           // Increase ball bounciness temporarily
            //           Matter.Body.set(ball, "restitution", 2); // Higher bounciness (1.0 is normal)
            //           // Add a slight spin effect to the pin for natural wobble
            //           Matter.Body.setAngularVelocity(
            //             pin,
            //             (Math.random() - 0.5) * 0.3 // Stronger wobble
            //           );
            //           // Ensure pin settles down smoothly after wobble
            //           Matter.Body.set(pin, "angularDamping", 0.03);
            //         }
            //       }
            //     }
            //   });
            // }
          } catch (error) {
            console.log(error);
            toast.warn(response.message || "Bet failed");
          }
        }
      );
    });
  };

  useEffect(() => {
    return () => {
      if (socket) {
        // socket.off("config");
        // socket.off("betHistory");
        // socket.off("betHistoryPayouts");
        // socket.off("bets");
      }
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on("refund", (response) => {
        console.log("refund", response);
        if (response.refund) {
          toast.warn(response.refund);
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    if (socket) {
      socket.emit("getChartData", {}, (response) => {
        if (response.status) {
          setFinanceChart(response.data);
          console.log("financeReport", response.data);
        }
      });
    }
  }, [refreshGraph]);

  const handleMaxBetEnabled = () => {
    setOpenInfoModal(!openInfoModal);
    setFormData((prevState) => ({
      ...prevState,
      bet_amount: gameConfig ? gameConfig?.max_bet : 0,
    }));
  };

  const storeResultEvent = (amt, id, payout, color, multiplier) => {
    if (activeTab == "tab2" && formData.num_of_bet) {
      setRemain(remain > 0 ? remain - 1 : 0);
    }

    socket.emit(
      "result",
      {
        result: amt,
        id: id,
        payout: payout,
        color: color,
        multiplier: multiplier,
      },
      (response) => {
        console.log("result came")
        setManualBetStarted(false);

        setAutoBetStarted(false);
        if (response.status) {
          if(response?.max_win) {
            toast.success(response.max_win)
          }
          socket.emit("betHistory", {}, (betResponse) => {
            setBetHistory(betResponse.data);
          });
          socket.emit("betHistoryPayouts", {}, (betResponse) => {
            setBetHistoryPayouts(betResponse.data);
          });
          socket.emit("userDetails", {}, (userReponse) => {
            if (userReponse.status) {
              setResultDone(true);
              setUserDetails(userReponse.data);
              if (activeTab == "tab1") {
                setFormData((prevState) => ({
                  ...prevState,
                  bet_amount: 0,
                  num_of_bet: 0,
                }));
              }
            } else {
              toast.warn(userReponse.message);
            }
          });
        } else {
          toast.warn(response.message);
        }
      }
    );
  };

  async function runAutoBets() {
    setStartResolve({ bool: false, numOf: 0 });
    for (let i = 1; i <= Number(formData?.num_of_bet); i++) {
      console.log("runAutoBets:- place from here", formData?.num_of_bet);
      const result = await placeBet(0); // Wait for the current bet to finish
      // console.log(`Bet ${i} completed with result: ${result}`);
    }
    // console.log("All bets completed.");
  }

  return (
    <div id="flipScreen">
      <AudioModal open={audioAllowModal} setOpen={setAudioAllowModal} />
      <div className="bg-181D29 top-1 right-0 absolute px-3 pt-1 font-bold flex justify-end align-center">
        {/* <div>
              <img src={PlinkoLogo} alt="Logo" width={"auto"} height={"auto"} />
            </div> */}

        <div className="flex" style={{ position: "absolute", zIndex: "100" }}>
          <div className="relative inline-block">
            <button
              data-popover-target="popover-user-profile"
              type="button"
              className="text-white bg-262E3A font-medium rounded-lg text-sm px-5 py-2.5 text-center flex justify-between "
            >
              <img
                src={CoinImage}
                className="absolute  left-3 text-gray-400 cursor-pointer"
              />
              {userDetails?.balance?.toFixed(2) || 0}
            </button>
          </div>

          <div className="relative inline-block  ml-2">
            <button
              data-popover-target="popover-user-profile flex user-icon"
              type="button"
              className="rounded-lg text-sm"
              onMouseOver={() => setOpenProfielPopover(true)}
              onMouseOut={() => setOpenProfielPopover(false)}
            >
              <img src={UserIcon} alt="User" className="user-icon" />
            </button>
            {openProfilePopover && (
              <div
                data-popover
                id="popover-user-profile"
                role="tooltip"
                className="absolute z-10 profile-popover mt-2 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-xs opacity-1"
              >
                <div className="p-3">
                  <p className="text-base font-semibold leading-none text-gray-900 dark:text-white">
                    <a href="#">{userDetails?.name || ""}</a>
                  </p>
                  <p className="mb-3 text-sm font-normal">
                    <a href="#" className="hover:underline">
                      {userDetails?.username || ""}
                    </a>
                  </p>
                </div>
                <div data-popper-arrow></div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row mt-1 h-screen bg-181D29">
        <div
          className={`flex-1  hide-scrollbar min-h-screen transition-all duration-300 bg-181D29 ${
            openBetHistory ? "opacity-low" : "opacity-high"
          }`}
        >
          <div className=" min-h-screen bg-181D29 rounded m-auto px-3 pb-3">
            <div className="flex flex-wrap-reverse h-full mt-auto">
              {/*  */}
              <div
                className="mx-auto xl:w-1/4 rounded-lg"
                style={{ background: "rgb(47, 69, 83)" }}
              >
                {/* mb-[100px] */}
                <div className="max-w-xl mx-auto p-2 rounded-lg">
                  <div className="flex rounded ms-2 mr-2 mt-3">
                    <button
                      onClick={() => setActiveTab("tab1")}
                      className={`py-2 px-4 w-1/2 flex-1 text-center ${
                        activeTab === "tab1"
                          ? "text-white font-bold bg-262E3A p-1"
                          : "text-gray-500 hover:text-white bg-202531"
                      }`}
                      disabled={autoBetStarted}
                    >
                      Manual
                    </button>

                    <button
                      onClick={() => setActiveTab("tab2")}
                      className={`py-2 px-4 w-1/2 flex-1 text-center ${
                        activeTab === "tab2"
                          ? "text-white font-bold bg-262E3A p-1"
                          : "text-gray-500 hover:text-white bg-202531"
                      }`}
                      disabled={manualBetStarted}
                    >
                      Auto
                    </button>
                  </div>

                  <div className="pt-2 pb-4">
                    <div
                      className={`peer-checked/tab1:block peer-checked/tab2:hidden`}
                    >
                      <form className={(!autoBetProcessDone || manualBetStarted) ? "pointer-events-none opacity-50 disabled:cursor-not-allowed mx-auto" : ` mx-auto`} disabled={!autoBetProcessDone}>
                        {/* max-w-sm */}
                        <div className=" flex">
                          <div className="w-75">
                            <InputComponent
                              type={"text"}
                              label={"Bet Amount"}
                              placeholder={"Bet amount"}
                              value={formData?.bet_amount}
                              required={false}
                              name={"bet_amount"}
                              handleChange={(e) => handleChange(e)}
                              icon={true}
                              disabled={
                                activeTab == "tab1"
                                  ? manualBetStarted
                                  : activeTab == "tab2"
                                  ? autoBetStarted
                                  : false
                              }
                            />
                          </div>
                          <div className="flex w-25 align-items-end">
                            <div
                              onClick={() => {
                                if(activeTab == "tab2" && autoBetProcessDone) {
                                  if (
                                    formData.bet_amount / 2 <=
                                    gameConfig.min_bet
                                  ) {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: gameConfig.min_bet,
                                    }));
                                  } else {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: formData.bet_amount / 2,
                                    }));
                                  }
                                } else if(activeTab == "tab1" && !manualBetStarted) {
                                  if (
                                    formData.bet_amount / 2 <=
                                    gameConfig.min_bet
                                  ) {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: gameConfig.min_bet,
                                    }));
                                  } else {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: formData.bet_amount / 2,
                                    }));
                                  }
                                }
                                
                              }}
                             
                              className={
                                "cursor-not-allowed mr-1 mb-2 w-full h-[40px] bg-202531 border-0 border-transparent text-center align-content-center cursor-pointer rounded-[5px] text-[16px] font-bold text-white " +
                                (activeTab == "tab1"
                                  ? manualBetStarted
                                  : activeTab == "tab2"
                                  ? autoBetStarted
                                  : false
                                  ? " cursor-none"
                                  : " ") 
                              }
                            >
                              1/2x
                            </div>
                            <div
                              onClick={() => {
                                if(activeTab == "tab2" && autoBetProcessDone) {
                                  if (
                                    formData.bet_amount * 2 >=
                                    gameConfig.max_bet
                                  ) {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: gameConfig.max_bet,
                                    }));
                                  } else {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: formData.bet_amount * 2,
                                    }));
                                  }
                                } else if(activeTab == "tab1" && !manualBetStarted) {
                                  if (
                                    formData.bet_amount * 2 >=
                                    gameConfig.max_bet
                                  ) {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: gameConfig.max_bet,
                                    }));
                                  } else {
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      bet_amount: formData.bet_amount * 2,
                                    }));
                                  }
                                }
                                
                              }}
                             
                              className={
                                " ml-1 mr-1 mb-2 w-full h-[40px] bg-202531 border-0 border-transparent text-center align-content-center cursor-pointer rounded-[5px] text-[16px] font-bold text-white " +
                                (activeTab == "tab1"
                                  ? manualBetStarted
                                  : (
                                      activeTab == "tab2"
                                        ? autoBetStarted
                                        : false
                                    )
                                  ? " cursor-none"
                                  : " ")
                              }
                            >
                              2x
                            </div>
                          </div>
                        </div>

                        <div className="">
                          <SelectComponent
                            label={"Risk"}
                            options={riskOptions}
                            value={formData?.risk}
                            required={false}
                            handleChange={handleChangeSelection}
                            disabled={
                              activeTab == "tab1"
                                ? manualBetStarted
                                : activeTab == "tab2"
                                ? autoBetStarted
                                : false
                            }
                          />
                        </div>


                    
                        <div className="mx-2 my-2">
                          <label className="block mb-2 text-sm font-medium text-white">
                            Rows
                          </label>

                          <div className={"grid grid-cols-9 mt-2"}>
                            {[8, 9, 10, 11, 12, 13, 14, 15, 16]?.map(
                              (item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={`bg-202531 m-[1px] my-[1.5px] text-center align-content-center  cursor-pointer rounded-[5px] text-[16px] font-bold ${
                                      formData?.rows == item
                                        ? "bg-00E701 text-12151D"
                                        : "text-white"
                                    }`}
                                    onClick={() => {
                                      if (manualBetStarted || autoBetStarted) {
                                      } else {
                                        setPlay(false);
                                        setFormData((prevState) => ({
                                          ...prevState,
                                          rows: item,
                                        }));
                                      }
                                    }}
                                  >
                                    {item}
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                        {activeTab == "tab2" && (
                          <div className="">
                            <InputComponent
                              type={"text"}
                              label={"Number of Bet"}
                              placeholder={"Number of Bet"}
                              value={formData?.num_of_bet}
                              required={false}
                              name={"num_of_bet"}
                              handleChange={handleChange}
                              icon={false}
                              disabled={
                                activeTab == "tab1"
                                  ? manualBetStarted
                                  : autoBetStarted
                              }
                            />
                            <label className="block mb-2 ms-2 text-sm font-medium text-white">
                              No. of remain bet: {remain}
                            </label>
                          </div>
                        )}
                        {activeTab == "tab1" ? (
                          <div className="mt-4 font-bold">
                            <ButtonComponent
                              buttonName={"Bet"}
                              disabled={
                                activeTab == "tab1"
                                  ? manualBetStarted
                                  : autoBetStarted
                              }
                              handleClick={() => {
                                if (!formData?.bet_amount) {
                                  toast.warn(`Invalid bet amount`);
                                  return;
                                }

                                if (
                                  Number(formData?.bet_amount) >
                                  gameConfig.max_bet
                                ) {
                                  toast.warn(
                                    `You cannot enter bet amount more than max bet amount (${gameConfig.max_bet}).`
                                  );
                                  return;
                                }

                                setStopAuto(false);

                                console.log("place from here 2015")
                                placeBet();
                              }}
                            />
                          </div>
                        ) : (
                          <div className="mt-3 font-bold">
                            <ButtonComponent
                              buttonName={
                                autoBetProcessDone
                                  ? "Start Autobet"
                                  : "Finishing Bet"
                              }
                              disabled={!autoBetProcessDone}
                              handleClick={() => {
                                setStopAuto(false);
                                if (
                                  Number(formData?.bet_amount) >
                                  gameConfig.max_bet
                                ) {
                                  toast.warn(
                                    `You cannot enter bet amount more than max bet amount (${gameConfig.max_bet}).`
                                  );
                                  return;
                                }
                                if (
                                  Number(formData?.bet_amount) <
                                  gameConfig.min_bet
                                ) {
                                  toast.warn(
                                    `Bet amount should be more than (${gameConfig.min_bet}).`
                                  );
                                  return;
                                }

                                if (formData.num_of_bet > 0) {
                                  setAutoBetProcessDone(false);
                                  runAutoBets()
                                    .then((results) => {
                                      console.log("All bet results:", results);
                                    })
                                    .catch((error) => {
                                      console.error(
                                        "Auto-bet process encountered an error:",
                                        error
                                      );
                                    })
                                    .finally(() => {
                                      setAutoBetProcessDone(true);
                                      console.log(
                                        "Auto-bet process is completely done (success or fail)."
                                      );
                                    });
                                } else {
                                  toast.warn("please fill required data");
                                }
                              }}
                            />
                            {/* <ButtonComponent
                              buttonName={"Stop"}
                              handleClick={() => {
                                console.log(
                                  "remain",
                                  remain,
                                  formData.num_of_bet
                                );
                                setStopAuto(true);
                                // setRemain(0)
                                // setStartResolve({ bool: false, numOf: 0 })
                              }}
                              disabled={autoBetProcessDone}
                            /> */}
                          </div>
                        )}
                      </form>
                      {activeTab == "tab2" &&  <ButtonComponent
                              buttonName={"Stop"}
                              handleClick={() => {
                               
                                setStopAuto(true);
                                // setRemain(0)
                                // setStartResolve({ bool: false, numOf: 0 })
                              }}
                              disabled={autoBetProcessDone}
                            />}
                     
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full xl:w-3/4 border-black rounded-lg">
                <div className="flex flex-col flex-row justify-center items-center">
                  <div className="w-full lg:w-3/4">
                    <div className="bg-181D29 rounded-lg my-2">
                      {/* payoutTable && */}
                      {payoutTable && formData.risk && formData.rows ? (
                        <PlinkoEngineNew
                          ballColor={gameConfig?.drop_ball_color}
                          rowCount={formData.rows}
                          resultantData={resultantData}
                          payoutTable={payoutTable}
                          risk={formData.risk}
                          hitAudio={
                            gameConfig?.balldrop_sound_url || BallBounce
                          }
                          
                          audioVolume={audioVolume}
                          startResolve={startResolve}
                          setStartResolve={setStartResolve}
                          setGridColor={setGridColor}
                          audioAllowModal={audioAllowModal}
                        />
                      ) : (
                        <div className="text-center m-auto">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      )}

                      {/* <div ref={containerRef}></div> */}
                    </div>
                  </div>
                  {/* // mt-4 hidden md:block lg:mt-0 overflow-y-auto h-[230px] hide-scrollbar min-w-[70px] */}
                  <div className="mt-4  md:block lg:mt-0 overflow-y-auto h-[230px]">
                    {betHistoryPayout?.slice(0, 5)?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            backgroundColor: `${item.color}`,
                            color: "rgb(47, 69, 83)",
                          }}
                          className={`m-1 text-center align-content-center hidden md:block cursor-pointer rounded-[5px]
                                h-[30px] sm:h-[30px] md:h-[30px] lg:h-[40px] xs:h-[40px]
                                text-[12px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[16px]
                                 w-[30px] sm:w-[30px] md:w-[40px] lg:w-[50px] xl:w-[50px] font-bold `}
                        >
                          {item.payout}x
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="w-[fit-content] mx-auto flex overflow-x-scroll block md:hidden hide-scrollbar">
                  {betHistoryPayout?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          backgroundColor: `${item.color}`,
                          color: "rgb(47, 69, 83)",
                        }}
                        className={`m-1  text-center align-content-center  cursor-pointer 
                          rounded-[5px] min-w-[35px]
                                h-[30px] sm:h-[30px] md:h-[30px] lg:h-[40px] xs:h-[40px]
                                text-[12px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[16px]
                                 w-[30px] sm:w-[30px] md:w-[40px] lg:w-[50px] xl:w-[50px] font-bold`}
                      >
                        {item.payout}x
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="bg-181D29 fixed bottom-0 border-t-[5px] border-black w-full p-1 sm:p-2 md:p-2 lg:p-2 xl:p-2 mt-1">
          <div className="flex justify-between">
            <div className="flex md:mt-4 lg:mt-4 xl:mt-4 sm:justify-center mt-0">
              <button
                data-popover-target="popover-user-profile flex user-icon"
                type="button"
                className="relative"
                onClick={() => setIsHovered(!isHovered)}
              >
                <IoSettingsOutline color="#fff" className="m-2" />
              </button>

              {isHovered && (
                <div
                  data-popover
                  id="popover-user-profile"
                  role="tooltip"
                  className="absolute z-10 inline-block w-64 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-xs opacity-1 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600 
                           bottom-full mb-2 left-[2%] bottom-[60%]"
                >
                  <div className="p-3">
                    <ul className="space-y-1">
                      <li className="flex items-center gap-2 text-12151D">
                        <IoVolumeHighSharp color={"#181D29"} size={20} />
                        <input
                          type="range"
                          value={audioVolume}
                          min="0"
                          max="1"
                          step="0.1"
                          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                          onChange={(e) => {
                            changeVolume(Number(e?.target?.value));
                            setAudioVolume(Number(e?.target?.value));
                          }}
                          style={{
                            background: `linear-gradient(to right, #1475E1 0%, #1475E1 ${
                              audioVolume * 100
                            }%, gray ${audioVolume * 100}%, gray 100%)`,
                          }}
                        />
                      </li>
                      {list?.map((itm, index) => {
                        return (
                          <li
                            key={index}
                            className="flex items-center gap-2 text-12151D cursor-pointer"
                            onClick={() => {
                              setOpenInfoModal(true);
                              setInfoModalData(itm);
                            }}
                          >
                            {itm.icon}
                            {itm.title}
                          </li>
                        );
                      })}
                    </ul>
                    <div
                      className="absolute w-3 h-3 bg-white rotate-45"
                      style={{ marginTop: "10px" }}
                    ></div>
                  </div>
                  <div data-popper-arrow></div>
                </div>
              )}

              <button
                className="cursor-pointer"
                onClick={() => {
                  socket.emit("getChartData", {}, (response) => {
                    if (response.status) {
                      setFinanceChart(response.data);
                      setOpenLiveStatModal(true);
                    }
                  });
                }}
              >
                <IoBarChartOutline color="#fff" className="m-2" />
              </button>
            </div>
            <div
              className="flex me-3 md:mt-4 lg:mt-4 xl:mt-4 sm:justify-center mt-0 items-center cursor-pointer"
              onClick={() => setOpenBetHistory(true)}
            >
              <span className="text-md  text-white font-semibold sm:text-center cursor-pointer items-center">
                My Bets
              </span>
            </div>
          </div>
        </footer>
      </div>

      {/* <WebAudioPlayer inputVolume={audioVolume} play={play} /> */}

      {openBetHistory ? (
        <div className="mt-1">
          <BetHistory
            data={betHistory}
            openBetHistory={openBetHistory}
            setOpenBetHistory={setOpenBetHistory}
          />
        </div>
      ) : (
        ""
      )}
      {openInfoModal ? (
        <div className="mt-1">
          <InfoModel
            openInfoModal={openInfoModal}
            setOpenInfoModal={setOpenInfoModal}
            infoModalData={infoModalData}
            setInfoModalData={setInfoModalData}
            gameConfig={gameConfig}
            handleMaxBetEnabled={handleMaxBetEnabled}
            audioVolume={audioVolume}
            setAudioVolume={setAudioVolume}
          />
        </div>
      ) : (
        ""
      )}
      {openLiveStatModal ? (
        <div className="mt-1">
          <LiveStatsModal
            openLiveStatModal={openLiveStatModal}
            setOpenLiveStatModal={setOpenLiveStatModal}
            data={userDetails}
            financeChart={financeChart}
            setFinanceChart={setFinanceChart}
            refreshGrap={refreshGraph}
            setRefreshGraph={setRefreshGraph}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
